import { render } from "./LandingPageComponent.vue?vue&type=template&id=80356bc2&scoped=true"
import script from "./LandingPageComponent.vue?vue&type=script&lang=js"
export * from "./LandingPageComponent.vue?vue&type=script&lang=js"

import "./LandingPageComponent.vue?vue&type=style&index=0&id=80356bc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80356bc2"]])

export default __exports__